import React, { useMemo } from 'react';
import { Button } from 'antd';
import { selectors, stateKeys } from '../../model';
import { useStoreSelector } from './../../hooks/useStoreSelector';
import { useHandlers } from '../../contexts';
import styles from './AllSelection.module.scss';

const { selectValue } = selectors;

const deselectDisabledSelector = (state) => {
  const value = selectValue(state, stateKeys.currentValue);
  return !value?.length;
};
const selectDisabledSelector = (state) => {
  const value = selectValue(state, stateKeys.currentValue);
  const optionsCount = selectValue(state, stateKeys.optionsCount);
  return value?.length === optionsCount;
};
const optionsSelector = (state) => selectValue(state, stateKeys.options);

const DeselectBtn = ({ onChange, ...props }) => {
  const disabled = useStoreSelector(deselectDisabledSelector);

  return (
    <Button {...props} disabled={disabled} onClick={() => onChange([])}>
      Снять все
    </Button>
  );
};

const SelectBtn = ({ onChange, ...props }) => {
  const disabled = useStoreSelector(selectDisabledSelector);
  const options = useStoreSelector(optionsSelector);

  const values = useMemo(
    () =>
      options
        .filter((option) => 'value' in option)
        .map((option) => option.value),
    [options]
  );

  return (
    <Button {...props} disabled={disabled} onClick={() => onChange(values)}>
      Выбрать все
    </Button>
  );
};

const AllSelection = () => {
  const { onValueChange } = useHandlers();

  const props = {
    type: 'link',
    className: styles.action,
    onChange: onValueChange,
  };

  return (
    <div className={styles.root}>
      <SelectBtn {...props} />
      <DeselectBtn {...props} />
    </div>
  );
};

export default AllSelection;
